import { useMediaQuery } from '@material-ui/core';
import { getLangue, Langues } from '../../../../utils';

export const getNbTagDansCard = (
    isOffreSelectionnee: boolean,
    isOffrePromo: boolean
): number => {
    let nbTag = 0;
    if (isOffreSelectionnee) {
        nbTag++;
    }
    if (isOffrePromo) {
        nbTag++;
    }

    return nbTag;
};

export const getCardTitleMarginBottom = (
    isTitreSurDeuxLigne: boolean,
    isVoisinTitreSurDeuxLigne: boolean,
    nbTagDansCard: number,
    nbTagVoisin: number
): string => {
    const isTablet = useMediaQuery('(max-width:991px)');

    // step 1 - aller chercher la marge de base
    let offsetMargin = 0;
    const startingMargin = getStartingMargin(
        isTitreSurDeuxLigne,
        nbTagDansCard,
        nbTagVoisin > 0 || isVoisinTitreSurDeuxLigne
    );

    // step 2 - trouver le nombre lignes prisent par des tag
    // si l'ecran est plus gros que 1440px et la langue est en FR c'est 2 tags sur 1 ligne
    const nbLigneDeTagDansCard = getIsDeuxTagSurUneLigne()
        ? Math.ceil(nbTagDansCard / 2)
        : nbTagDansCard;
    const nbLigneDeTagVoisin = getIsDeuxTagSurUneLigne()
        ? Math.ceil(nbTagVoisin / 2)
        : nbTagVoisin;

    // step 3 - ajustement de marge baser sur le voisin (si moins de contenu que le voisin doit ajuster sinon non)
    // calcul espace total pris par le titre + tags
    //      titre: 3rem (deux ligne: 5rem) (2rem par ligne + 1 rem de mb)
    //      tag: 2.5rem (1.5rem de tag + 1rem marginBottom)
    const espacePrisParTitreEtTag =
        (isTitreSurDeuxLigne ? 5 : 3) + nbLigneDeTagDansCard * 2.5;
    const espacePrisParTitreEtTagVoisin =
        (isVoisinTitreSurDeuxLigne ? 5 : 3) + nbLigneDeTagVoisin * 2.5;

    if (espacePrisParTitreEtTag < espacePrisParTitreEtTagVoisin) {
        offsetMargin = espacePrisParTitreEtTagVoisin - espacePrisParTitreEtTag;
    }

    // en tablet on a pas besoin d'ajouter le offset margin car les offres
    // sont une par range donc pas besoin d'aligner les taux
    return isTablet
        ? String(startingMargin) + 'rem'
        : String(startingMargin + offsetMargin) + 'rem';
};

export const getIsDeuxTagSurUneLigne = (): boolean => {
    const isEcranMedium = useMediaQuery('(max-width:1440px)');
    return !isEcranMedium && getLangue() === Langues.FR;
};

// Le starting margin est la marge qu'on va garder
// seulement si il n'y a pas d'ajustement par la suite
// Si le voisin contient quelque chose on veut aussi que la marge
// commence a 1rem parce qu'elle va ce faire ajuster par la suite
const getStartingMargin = (
    isTitreSurDeuxLigne: boolean,
    nbTagDansCard: number,
    isVoisinTitreSurDeuxLigneOuContientUnTag: boolean
): number => {
    const isTablet = useMediaQuery('(max-width:991px)');
    let startingMargin = 2;

    // si tablet on veut que seulement les tags aillent une marge de 1 rem
    if (
        nbTagDansCard > 0 ||
        ((isTitreSurDeuxLigne || isVoisinTitreSurDeuxLigneOuContientUnTag) &&
            !isTablet)
    ) {
        startingMargin = 1;
    }

    return startingMargin;
};
